import moment from 'moment';
import Chart from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom';
import { FunnelController, TrapezoidElement } from 'chartjs-chart-funnel';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chartjs-adapter-moment';
import 'popper.js';
import { groupPointsByUnit } from './analytics-point-aggregation';

// register controller in chart.js and ensure the defaults are set
Chart.register(FunnelController, TrapezoidElement, zoomPlugin, );

window.analitics = (params) => {
    moment.locale('ru');

    let timer = null
    let data = null

    let chartCalls = null
    let lineChartPoints = {}
    let chartDirections = null
    let chartTrafficSources = null
    let chartObjection = null
    let chartObjectionResult = null
    let chartErrors = null
    let funnelChart = null
    let funnelChartNoSignet = null
    let economicEffectConversionChart = null
    let currentRequest = null
    let requestSeq = 0

    let dateGrouping = 'day';
    let typeCalls = 'percent';

    const type = params.type
    const stages = params.stages
    const url = params.url
    const pointsOnly = params.pointsOnly || false
    const totalTitle = params.totalTitle || 'Итоговая эффективность'
    let economicEffect = params.economicEffect || null

    const init = () => {
        renderEconomicEffectDashboard()
        initLoadingIndicator()
        event()
        handlerFilter()
    }

    /**
     * Обновляет показатели окупаемости и график конверсии для выбранной компании.
     * Блок скрывается, если у компании ещё нет месячных снимков отчёта.
     */
    const renderEconomicEffectDashboard = () => {
        const block = document.querySelector('.director-economic-effect')
        if (!block) {
            return
        }

        const hasData = economicEffect !== null && economicEffect.labels?.length > 0
        $(block).toggle(Boolean(hasData))

        if (!hasData) {
            economicEffectConversionChart?.destroy()
            economicEffectConversionChart = null
            return
        }

        $('#economicEffectRescuedCount').text(economicEffect?.rescued_count ?? 0)
        $('#economicEffectRoi').text(economicEffect?.roi == null ? '—' : Math.round(economicEffect.roi) + '%')

        const canvas = document.getElementById('economicEffectConversionChart')
        if (!canvas) {
            return
        }

        economicEffectConversionChart?.destroy()
        economicEffectConversionChart = new Chart(canvas.getContext('2d'), {
            type: 'line',
            data: {
                labels: economicEffect.labels,
                datasets: [{
                    label: 'Конверсия клиники, %',
                    data: economicEffect.conversion,
                    borderColor: 'rgb(40, 167, 69)',
                    backgroundColor: 'rgba(40, 167, 69, .14)',
                    borderWidth: 3,
                    fill: true,
                    pointBackgroundColor: 'rgb(40, 167, 69)',
                    pointRadius: 3,
                    pointHoverRadius: 5,
                    tension: .3,
                    spanGaps: true
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: context => [
                                'Конверсия: ' + Math.round(context.parsed.y * 100) / 100 + '%',
                                'Спасённые пациенты: ' + (economicEffect.rescued_by_month?.[context.dataIndex] ?? 0)
                            ]
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        suggestedMax: 100,
                        ticks: {
                            callback: value => value + '%'
                        }
                    },
                    x: {
                        grid: { display: false }
                    }
                }
            }
        })
    }

    const initLoadingIndicator = () => {
        if ($('#analiticsLoading').length) {
            return
        }

        const $container = $('.analitics-data').length ? $('.analitics-data') : $('.analitics')

        $container.append(
            '<div id="analiticsLoading" class="analitics-loading" aria-hidden="true">' +
                '<div class="spinner-border spinner-border-sm text-primary" role="status"></div>' +
                '<span>Обновление данных</span>' +
            '</div>'
        )
    }

    const setLoading = (isLoading) => {
        $('#analiticsLoading')
            .toggleClass('show', isLoading)
            .attr('aria-hidden', isLoading ? 'false' : 'true')
    }


    const event = () => {
        $('#directions').on('select2:opening', function () {
            const $select = $(this)
            $select.data('select2').options.set('templateResult', result => {
                if (!result.children || !result.element?.dataset.selectGroup) {
                    return result.text
                }

                return $('<button type="button" class="btn btn-link p-0 font-weight-bold text-left w-100">')
                    .text(result.text)
                    .attr('title', 'Выбрать все направления группы')
                    .on('mousedown mouseup', event => event.stopPropagation())
                    .on('click', event => {
                        event.preventDefault()
                        event.stopPropagation()
                        // Выбираем всю группу, даже если поиск скрыл часть её направлений.
                        const groupIds = Array.from(result.element.children)
                            .filter(option => !option.disabled)
                            .map(option => option.value)
                        $select.val([...new Set([...($select.val() || []), ...groupIds])]).trigger('change')
                        $select.select2('close')
                    })
            })
        })

        // добавляем обработчик для группировки дат
        $("#date_from, #date_to, #first, #price, #status_signed, #directions, #subjects, #company, #admin, #patient_type").on('change', function () {
            clearTimeout(timer)

            timer = setTimeout(handlerFilter, 2000)
        })

        $('#dateGrouping').on('change', function () {
            dateGrouping = $(this).val()
            render()
        })

        $('#typeCalls').on('change', function () {
            typeCalls = $(this).val()
            render()
        })

        // добавляем обработчик для переключателей datasets
        $("#dataset-toggle-line-chart").on('change', function() {

            const selectedValues = $(this).val() || [];
            for (let chartId in lineChartPoints) {
                let chart = lineChartPoints[chartId]
                chart.data.datasets.forEach((dataset, index) => {
                    console.log(selectedValues, dataset.label)
                    const isVisible = selectedValues.includes(dataset.label);
                    chart.setDatasetVisibility(index, isVisible);
                });
                chart.update();
            };
        });
    }

    const handlerFilter = () => {

        if (!$('#date_from').val() && $('#date_to').val()) {
            alert('Не выбраны даты')
        }

        const currentSeq = ++requestSeq

        if (currentRequest) {
            currentRequest.abort()
        }

        setLoading(true)

        currentRequest = $.post(url, {
            date_from: $('#date_from').val(),
            date_to: $('#date_to').val(),
            first: $('#first').val(),
            price: $('#price').val(),
            admin: $('#admin').val(),
            directions: $('#directions').val(),
            subjects: $('#subjects').val(),
            company: $('#company').val(),
            patient_type: $('#patient_type').val() || params.patientType,
            date_grouping: $('#dateGrouping').val()
        }).done((result) => {
            if (currentSeq !== requestSeq) {
                return
            }

            data = result
            economicEffect = result.economic_effect || null
            renderEconomicEffectDashboard()
            render()
        }).fail((xhr, status) => {
            if (status === 'abort' || currentSeq !== requestSeq) {
                return
            }

            console.error('Ошибка обновления аналитики', xhr)
        }).always(() => {
            if (currentSeq !== requestSeq) {
                return
            }

            currentRequest = null
            setLoading(false)
        })
    }

    // обновляем функцию форматирования даты с учетом группировки
    const formatDate = (date, grouping = null) => {
        const currentGrouping = grouping || $('#dateGrouping').val() || 'day'

        if (date.length > 10) {
            switch(currentGrouping) {
                case 'week':
                    const startOfWeek = moment(date).startOf('week').format('DD.MM')
                    const endOfWeek = moment(date).endOf('week').format('DD.MM')
                    return `${startOfWeek} - ${endOfWeek}`
                case 'month':
                    return moment(date).format('MM.YYYY')
                case 'day':
                default:
                    return moment(date).format('DD.MM.YYYY')
            }
        } else {
            switch(currentGrouping) {
                case 'week':
                    const startOfWeek = moment(date).startOf('week').format('DD.MM')
                    const endOfWeek = moment(date).endOf('week').format('DD.MM')
                    return `${startOfWeek} - ${endOfWeek}`
                case 'month':
                    return moment(date).format('MM.YYYY')
                case 'day':
                default:
                    return moment(date).format('DD.MM.YYYY')
            }
        }
    }

    const getFunnelMetrics = () => {
        const total = Number(data?.all?.all ?? 0);
        const signed = Number(data?.all?.signed ?? 0);
        const successful = Number(data?.all?.conversion_successful_count ?? signed);
        const noSignRequired = Number(data?.all?.no_sign_required ?? 0);
        const waitingList = Number(data?.all?.waiting_list ?? 0);
        const conversionBase = Number(data?.all?.conversion_base ?? Math.max(total - noSignRequired - waitingList, 0));
        const notSigned = Number(data?.all?.not_signed ?? Math.max(conversionBase - signed, 0));
        const conversionPercent = Number(data?.all?.conversion_percent ?? (conversionBase > 0 ? Math.round((signed / conversionBase) * 100) : 0));

        return {
            total,
            signed,
            successful,
            noSignRequired,
            waitingList,
            excludedNoSignRequired: Number(data?.all?.excluded_no_sign_required ?? noSignRequired),
            excludedWaitingList: Number(data?.all?.excluded_waiting_list ?? waitingList),
            conversionBase,
            notSigned,
            conversionPercent
        };
    };

    const formatNumber = (value) => Number(value ?? 0).toLocaleString('ru-RU');

    const formatPercent = (value) => {
        const normalized = Number.isFinite(value) ? value : 0;
        return normalized.toFixed(0).replace('.', ',');
    };

    const applyFirstPatientTypeFilter = (filter) => {
        filter.analytics_patient_type = $('#patient_type').val() || params.patientType || 'first';
        filter.is_exception_error = 1;

        return filter;
    };

    // Все переходы к звонкам сохраняют выбранные направления, если график не задаёт конкретное.
    const getRecordsLink = (filter) => {
        return `/ii-call/record?${$.param({
            directions: $('#directions').val(),
            ...filter,
        })}`;
    };

    const getChartPointsLink = (userId, stage) => {
        const filter = {
            date_from: $('#date_from').val(),
            date_to: $('#date_to').val(),
            admin: userId,
        };

        switch (type) {
            case 'first':
                filter.recommendation_stage = stage;
                filter.recommendation_relation = '>';
                filter.recommendation_value = -1;
                applyFirstPatientTypeFilter(filter);
                break;
            case 'service':
                filter.recommendation_stage = stage;
                filter.recommendation_relation = '>';
                filter.recommendation_value = -1;
                filter.type = 'service';
                filter.service_type = 'patient_cancel';
                break;
            case 'marketing':
                filter.recommendation_stage = stage;
                filter.recommendation_relation = '>';
                filter.recommendation_value = -1;
                filter.type = 'marketing';
                filter.is_exception_error = 1;
                break;
            case 'total':
                if (stage === 'first') {
                    filter.first = 1;
                } else if (stage === 'service') {
                    filter.type = 'service';
                    filter.service_type = 'patient_cancel';
                } else if (stage === 'marketing') {
                    filter.type = 'marketing';
                    filter.is_exception_error = 1;
                }
                break;
        }

        return getRecordsLink(filter);
    };

    const renderConversionInfo = () => {
        const metrics = getFunnelMetrics();
        const conversionPercentText = metrics.conversionBase > 0
            ? formatPercent((metrics.successful / metrics.conversionBase) * 100)
            : '0';

        let conversionText = metrics.conversionBase > 0
            ? `${conversionPercentText}%`
            : '0%';

        if (type === 'service') {
            conversionText += `<br><small>Не требует переноса: ${formatNumber(metrics.noSignRequired)}</small>`;
        }

        $('.effects').html(`${conversionText}`);
    };



    const render = () => {
        if (!pointsOnly) {
            renderChartCalls(dateGrouping, typeCalls)

            renderChartDirections()

            renderChartTrafficSources()

            renderChartErrors()

            renderChartObjection()

            renderChartObjectionResult()

            renderFunnelChart()
        }

        $('#chartPoints').html('')
        if (data.points.length > 0) {

            let titleChartPoints = ''
            for (let stage in stages) {
                titleChartPoints += '<div class="chart-point-item">\n' +
                    '<div class="title">' + stages[stage] + '</div>' +
                    '</div>\n'
            }
            $('#chartPoints').append(
                '<div class="analitic-chart-points__header">' +
                '<div class="chart-points-row chart-points-row_header">\n' +
                '<div class="chart-point-item chart-point-item_user">\n' +
                '<div class="title">Администратор</div>' +
                '</div>\n' +
                '<div class="chart-point-item">\n' +
                '<div class="title">' + totalTitle + '</div>' +
                '</div>\n' +
                titleChartPoints +
                '</div>' +
                '</div>'
            )
        }
        data.points.forEach((userPoints, key) => {
            if (!userPoints.userId) return

            const user = data.users.find(item => item.id === userPoints.userId)

            let valueChartPoints = ''
            for (let stage in stages) {
                valueChartPoints += '<a class="chart-point-item chart-point-row" href="' + getChartPointsLink(user?.id, stage) + '" target="_blank">\n' +
                    '<div class="canvas"><canvas id="chartPoints_'+stage+'_' + key + '" style="min-height: 70px; max-height: 70px"></canvas>\n' +
                    '<div class="percent"></div></div>' +
                    '</a>\n'
            }

            $('#chartPoints').append(
                '<div class="callout callout-info chart-points-callout">' +
                    '<div class="chart-points-row align-items-center">\n' +
                        '<div class="chart-point-item chart-point-item_user">\n' +
                            '<p class="title">'+user?.name+'</p>\n' +
                        '</div>\n' +
                        '<a class="chart-point-item chart-point-row" href="' + getChartPointsLink(user?.id, 'total') + '" target="_blank">\n' +
                        '<div class="canvas"><canvas id="chartPoints_total_' + key + '" style="min-height: 70px; max-height: 70px"></canvas>\n' +
                        '<div class="percent"></div></div>' +
                        '</a>\n' +
                        valueChartPoints +
                    '</div>' +
                '</div>'
            )

            for (let stage in stages) {
                const length = userPoints.points.filter(item => stage in item.points).length
                if (userPoints.stagePercents && userPoints.stagePercents[stage] != null) {
                    renderChartPoints('chartPoints_' + stage + '_' + key, userPoints.stagePercents[stage])
                } else if (userPoints.stagePercents === undefined && length > 0) {
                    renderChartPoints('chartPoints_' + stage + '_' + key, userPoints.points.reduce((sum, item) => sum + (item.points[stage] ?? 0), 0) / length)
                } else {
                    $('#chartPoints_' + stage + '_' + key).next().html('N/A')
                        .attr("data-placement", "top")
                        .attr("title", "Данный этап не актуален")
                        .tooltip()

                }
            }
            const lengthTotal = userPoints.points.filter(item => 'total' in item.points).length
            if (userPoints.totalPercent != null) {
                renderChartPoints('chartPoints_total_' + key, userPoints.totalPercent)
            } else if (userPoints.totalPercent === undefined && lengthTotal > 0) {
                renderChartPoints('chartPoints_total_' + key, userPoints.points.reduce((sum, item) => sum + (item.points['total'] ?? 0), 0) / lengthTotal)
            } else {
                $('#chartPoints_total_' + key).next().html('N/A')
            }

        })

        if (!pointsOnly) {
            $('#lineChartPoints').html('')
            data.points.forEach((userPoints, key) => {
                if (!userPoints.userId) return

                const userName = data.users.find(item => item.id === userPoints.userId)?.name

                $('#lineChartPoints').append(
                    // '<div class="row">' +
                    '<div class="col-md-6 col-12">' +
                    '<div class="card">\n' +
                    '<div class="card-header">\n' +
                    '<h3 class="card-title">Эффективность администратора '+userName+'</h3>\n' +
                    '</div>\n' +
                    '<div class="card-body">\n' +
                    '<div class="row">\n' +
                    '<div class="col">\n' +
                    '<canvas id="lineChartPoints_' + key + '" style="min-height: 300px; max-height: 500px"></canvas>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '</div>' +
                    '</div>'
                    // '</div>'
                )

                renderLineChartPoints('lineChartPoints_' + key, userPoints.points, dateGrouping)
            })

            renderConversionInfo();
        }

    }

    // ===== НОВОЕ: утилиты для "округления" дат к началу интервала =====
    const startOfWeekMon = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        const day = d.getDay() || 7; // 1..7 (Пн..Вс), где Вс=7
        d.setDate(d.getDate() - (day - 1)); // к понедельнику
        return d;
    };

    const getBucketStart = (date, unit) => {
        const d = new Date(date);
        if (unit === 'hour') {
            d.setMinutes(0, 0, 0);
            return d;
        }
        if (unit === 'day') {
            d.setHours(0, 0, 0, 0);
            return d;
        }
        if (unit === 'week') {
            return startOfWeekMon(d);
        }
        if (unit === 'month') {
            d.setDate(1);
            d.setHours(0, 0, 0, 0);
            return d;
        }
        // дефолт: без группировки
        return d;
    };

// ===== НОВОЕ: группировка исходных строк по unit =====
    const groupCallsByUnit = (rows, unit) => {
        const buckets = new Map(); // key: ms timestamp, value: агрегированные данные

        for (const row of rows || []) {
            const bucketDate = getBucketStart(row.date, unit);
            const key = bucketDate.getTime();

            if (!buckets.has(key)) {
                buckets.set(key, {
                    date: bucketDate.toISOString(),
                    count: {},
                    totals: {
                        total_count: 0,
                        conversion_successful_count: 0,
                        effective_total_count: 0,
                        signed_count: 0,
                        not_signed_count: 0,
                        no_sign_required_count: 0,
                        waiting_list_count: 0,
                    }
                });
            }
            const bucket = buckets.get(key);
            const totals = bucket.totals;

            const totalCount = Number(
                row.total_count ??
                ((row.signed_count || 0) + (row.not_signed_count || 0) + (row.no_sign_required_count || 0) + (row.waiting_list_count || 0))
            );

            totals.total_count += totalCount;
            totals.conversion_successful_count += Number(row.conversion_successful_count ?? row.signed_count ?? 0);
            totals.effective_total_count += Number(row.effective_total_count ?? Math.max(totalCount - (row.no_sign_required_count || 0) - (row.waiting_list_count || 0), 0));
            totals.signed_count += Number(row.signed_count || 0);
            totals.not_signed_count += Number(row.not_signed_count || 0);
            totals.no_sign_required_count += Number(row.no_sign_required_count || 0);
            totals.waiting_list_count += Number(row.waiting_list_count || 0);

            // суммируем по всем userId, что есть в строке
            for (const userId in (row.count || {})) {
                const src = row.count[userId] || {};
                if (!bucket.count[userId]) bucket.count[userId] = { count: 0, all: 0, no_sign_required: 0, waiting_list: 0, conversion_successful_count: 0, effective_all: 0 };
                bucket.count[userId].conversion_successful_count += src.conversion_successful_count ?? src.count ?? 0;
                bucket.count[userId].effective_all += src.effective_all ?? Math.max((src.all || 0) - (src.no_sign_required || 0) - (src.waiting_list || 0), 0);
                bucket.count[userId].count += src.count || 0;
                bucket.count[userId].all   += src.all   || 0;
                bucket.count[userId].no_sign_required += src.no_sign_required || 0;
                bucket.count[userId].waiting_list += src.waiting_list || 0;
            }
        }

        // в массив + сортировка по дате
        return Array.from(buckets.values())
            .map(bucket => {
                const totals = bucket.totals;
                const effectiveTotal = totals.effective_total_count;

                return {
                    date: bucket.date,
                    count: bucket.count,
                    conversion_successful_count: totals.conversion_successful_count,
                    signed_count: totals.signed_count,
                    not_signed_count: totals.not_signed_count,
                    no_sign_required_count: totals.no_sign_required_count,
                    waiting_list_count: totals.waiting_list_count,
                    total_count: totals.total_count,
                    effective_total_count: effectiveTotal,
                };
            })
            .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
    };


    /**
     * Рендер графика звонков с time-осью и переключаемым форматированием дат.
     * @param {'hour'|'day'|'week'|'month'} unit - единица времени для оси X
     * @param {'percent'|'count'} typeCalls - режим значений
     */
    const renderChartCalls = (unit = 'day', typeCalls = 'count') => {
        const color = [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
        ];

        // сгруппированные строки
        const calls = groupCallsByUnit(data?.calls || [], unit);

        // подписи X (через formatDate)
        const labels = calls.map(row => formatDate(row.date));

        const getValue = (row, userId) => {
            const rec = row.count?.[userId];
            // если по пользователю нет данных в этом периоде — не выводим точку
            if (!rec) return null;
            if (typeCalls === 'percent') {
                const denominator = rec.effective_all ?? Math.max(
                    (rec.all || 0) - (rec.no_sign_required || 0) - (rec.waiting_list || 0),
                    0
                );
                return denominator > 0 ? Math.round(((rec.conversion_successful_count ?? rec.count) / denominator) * 100) : null;
            }
            return rec.count || 0;
        };

        // общий показатель
        const totalData = calls.map(row => {
            let totalCount = 0;
            for (const userId in (row.count || {})) {
                totalCount += row.count[userId]?.count || 0;
            }
            const effectiveAll = row.effective_total_count ?? Math.max(
                (row.total_count || 0) - (row.no_sign_required_count || 0) - (row.waiting_list_count || 0),
                0
            );

            if (typeCalls === 'percent') {
                return effectiveAll > 0 ? Math.round(((row.conversion_successful_count ?? totalCount) / effectiveAll) * 100) : 0;
            }

            return totalCount;
        });

        chartCalls?.destroy();

        chartCalls = new Chart(
            document.getElementById('chartCalls').getContext('2d'),
            {
                type: 'line',
                data: {
                    labels,
                    datasets: [
                        // по пользователям
                        ...(data?.users || []).map((user, key) => ({
                            label: user.name,
                            data: calls.map(row => getValue(row, user.id)),
                            borderColor: color[key % color.length],
                            backgroundColor: color[key % color.length],
                            borderWidth: 1,
                            fill: false,
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            pointRadius: 0,
                            spanGaps: true
                        })),

                        // "Не определен"
                        {
                            label: 'Не определен',
                            data: calls.map(row => getValue(row, "")),
                            borderColor: 'rgb(255, 99, 132)',
                            backgroundColor: 'rgba(255, 99, 132, 0.62)',
                            borderWidth: 1,
                            fill: false,
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            pointRadius: 0,
                            spanGaps: true
                        },

                        // Общий показатель
                        {
                            label: '📊 ОБЩИЙ ПОКАЗАТЕЛЬ',
                            data: totalData,
                            borderColor: 'rgb(236,98,98)',
                            backgroundColor: 'rgb(236,98,98)',
                            borderWidth: 4,
                            fill: false,
                            cubicInterpolationMode: 'monotone',
                            tension: 0.4,
                            pointRadius: 6,
                            pointHoverRadius: 8,
                            pointBackgroundColor: 'rgb(255, 215, 0)',
                            pointBorderColor: 'rgb(0, 0, 0)',
                            pointBorderWidth: 2
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: { mode: 'nearest', intersect: false },
                    scales: {
                        y: {
                            beginAtZero: true,
                            grace: '10%',
                            ticks: {
                                callback: (v) => typeCalls === 'percent' ? `${v}%` : v
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            backgroundColor: (ctx) => ctx.dataset.backgroundColor,
                            borderRadius: 4,
                            color: 'white',
                            font: { weight: 'bold' },
                            formatter: (v) => {
                                if (v == null || Number.isNaN(v)) {
                                    return '';
                                }
                                return Math.round(v);
                            },
                            padding: 6
                        },
                        legend: { position: 'bottom' },
                        tooltip: {
                            callbacks: {
                                title(items) {
                                    // берём уже отформатированную подпись
                                    return labels[items[0].dataIndex];
                                },
                                label(ctx) {
                                    const base = `${ctx.dataset.label || ''}: `;
                                    const val  = ctx.parsed.y ?? 0;
                                    return typeCalls === 'percent' ? `${base}${val}%` : `${base}${val}`;
                                }
                            }
                        }
                    }
                },
                plugins: [ChartDataLabels]
            }
        );
    };



    const renderChartDirections = () => {
        chartDirections?.destroy();

        chartDirections = new Chart(
            document.getElementById('chartDirections').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.directions?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Количество',
                            data: data?.directions?.map(row => row.count),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            admin: $('#admin').val(),
                            directions: data?.directions[index].id,
                            subjects: $('#subjects').val(),
                            company: $('#company').val(),
                        }

                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter);
                                break;
                            case 'service':
                                filter.type = 'service';
                                filter.service_type = 'patient_cancel';
                                break;
                            case 'marketing':
                                filter.type = 'marketing';
                                filter.is_exception_error = 1;
                                break;
                        }

                        window.open(getRecordsLink(filter), '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartTrafficSources = () => {
        chartTrafficSources?.destroy()

        const canvas = document.getElementById('chartTrafficSources')
        if (!canvas) return

        const sources = data?.traffic_sources || []
        const colors = sources.map((source, index) => {
            const hue = Math.round((index * 360) / Math.max(sources.length, 1))
            return `hsl(${hue}, 65%, 58%)`
        })

        chartTrafficSources = new Chart(
            canvas.getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: sources.map(source => source.name),
                    datasets: [{
                        label: 'Количество звонков',
                        data: sources.map(source => source.count),
                        backgroundColor: colors,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: context => context.dataset.backgroundColor[context.dataIndex],
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: value => value > 0 ? Math.round(value) : '',
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        },
                        tooltip: {
                            callbacks: {
                                label: context => {
                                    const total = context.dataset.data.reduce((sum, value) => sum + Number(value || 0), 0)
                                    const count = Number(context.raw || 0)
                                    const percent = total > 0 ? Math.round((count / total) * 100) : 0

                                    return `${context.label}: ${count} (${percent}%)`
                                }
                            }
                        }
                    },
                    onClick: (event, elements) => {
                        if (!elements.length) return

                        const source = sources[elements[0].index]
                        if (!source?.value) return

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            admin: $('#admin').val(),
                            subjects: $('#subjects').val(),
                            company: $('#company').val(),
                            traffic_source: source.value,
                        }

                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter)
                                break
                            case 'service':
                                filter.type = 'service'
                                filter.service_type = 'patient_cancel'
                                break
                            case 'marketing':
                                filter.type = 'marketing'
                                filter.is_exception_error = 1
                                break
                        }

                        window.open(getRecordsLink(filter), '_blank')
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartObjection = () => {
        chartObjection?.destroy();

        if (!document.getElementById('chartObjection')) return;

        chartObjection = new Chart(
            document.getElementById('chartObjection').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.objections?.type?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Количество',
                            data: data?.objections?.type?.map(row => row.count),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            objection: data?.objections?.type[index].key,
                            company: $('#company').val(),
                        }

                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter);
                                break;
                            case 'service':
                                filter.type = 'service';
                                filter.service_type = 'patient_cancel';
                                break;
                            case 'marketing':
                                filter.type = 'marketing';
                                filter.is_exception_error = 1;
                                break;
                        }

                        window.open(getRecordsLink(filter), '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartObjectionResult = () => {
        chartObjectionResult?.destroy();

        if (!document.getElementById('chartObjectionResult')) return;

        chartObjectionResult = new Chart(
            document.getElementById('chartObjectionResult').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: ['Отработаны', 'Не отработаны'],
                    datasets: [
                        {
                            label: 'Количество',
                            data: [
                                data?.objections?.result?.success,
                                data?.objections?.result?.fail
                            ],
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6,
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            objection_result: index === 0 ? 1 : 0,
                            company: $('#company').val(),
                        }

                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter);
                                break;
                            case 'service':
                                filter.type = 'service';
                                filter.service_type = 'patient_cancel';
                                break;
                            case 'marketing':
                                filter.type = 'marketing';
                                filter.is_exception_error = 1;
                                break;
                        }

                        window.open(getRecordsLink(filter), '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        )
    }

    const renderChartErrors = () => {
        chartErrors?.destroy();

        const sumErrors = data?.errors?.reduce((a, b) => a + b.count, 0)

        chartErrors = new Chart(
            document.getElementById('chartErrors').getContext('2d'),
            {
                type: 'pie',
                data: {
                    labels: data?.errors?.map(row => row.name),
                    datasets: [
                        {
                            label: 'Процент',
                            data: data?.errors?.map(row => Math.ceil(row.count / sumErrors * 100)),
                            backgroundColor: [
                                'rgb(255, 99, 132)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(75, 192, 192)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        datalabels: {
                            anchor: 'center',
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 25,
                            borderWidth: 2,
                            color: 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: Math.round,
                            padding: 6
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        const index = elements[0].index;

                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            error: data?.errors[index].key,
                            company: $('#company').val(),
                        }

                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter);
                                break;
                            case 'service':
                                filter.type = 'service';
                                filter.service_type = 'patient_cancel';
                                break;
                            case 'marketing':
                                filter.type = 'marketing';
                                filter.is_exception_error = 1;
                                break;
                        }

                        window.open(getRecordsLink(filter), '_blank');
                    }
                },
                plugins: [ChartDataLabels]

            }
        )
    }

    const renderFunnelChart = () => {
        const metrics = getFunnelMetrics();
        const conversionPercentText = metrics.conversionBase > 0
            ? formatPercent((metrics.successful / metrics.conversionBase) * 100)
            : '0,0';

        const excludedNote = `исключено: \n${formatNumber(metrics.excludedNoSignRequired)} — запись не требуется \n${formatNumber(metrics.excludedWaitingList)} — лист ожидания`;
        const conversionNote = metrics.conversionBase > 0
            ? `конверсия ${formatNumber(metrics.successful)} / ${formatNumber(metrics.conversionBase)} = ${conversionPercentText}%`
            : 'конверсия 0%';
        const scriptSuccessCount = Math.max(metrics.successful - metrics.signed, 0);
        const scriptSuccessNote = data?.all?.conversion_by_script_enabled
            ? `\nДополнительно по скрипту: ${formatNumber(scriptSuccessCount)}`
            : '';

        const firstFunnel = {
            labels: [
                'Всего звонков',
                `Релевантные для записи\n${excludedNote}`,
                `Успешные для конверсии\nЗаписались: ${formatNumber(metrics.signed)}${scriptSuccessNote}\n${conversionNote}`
            ],
            data: [
                metrics.total,
                metrics.conversionBase,
                metrics.successful,
            ],
            displayLabels: [
                formatNumber(metrics.total),
                formatNumber(metrics.conversionBase),
                formatNumber(metrics.successful),
            ],
            colors: ['#457de6', '#17a2b8', '#28a745'],
            statusMap: [null, null, 'Y']
        };

        const marketingFunnel = {
            labels: [
                'Всего маркетинговых звонков',
                `Релевантные для записи\n${excludedNote}`,
                `Записались\n${conversionNote}`
            ],
            data: [
                metrics.total,
                metrics.conversionBase,
                metrics.signed,
            ],
            displayLabels: [
                formatNumber(metrics.total),
                formatNumber(metrics.conversionBase),
                formatNumber(metrics.signed),
            ],
            colors: ['#457de6', '#17a2b8', '#28a745'],
            statusMap: [null, null, 'Y']
        };

        const serviceExcludedNote = `исключено: \n${formatNumber(metrics.noSignRequired)} — перенос не требуется \n${formatNumber(metrics.waitingList)} — лист ожидания`;
        const serviceConversionNote = metrics.conversionBase > 0
            ? `конверсия ${formatNumber(metrics.signed)} / ${formatNumber(metrics.conversionBase)} = ${conversionPercentText}%`
            : 'конверсия 0%';
        const serviceFunnel = {
            labels: [
                'Отменили прием',
                `Требуется перенос\n${serviceExcludedNote}`,
                `Перезаписались\n${serviceConversionNote}`
            ],
            data: [
                metrics.total,
                metrics.conversionBase,
                metrics.signed,
            ],
            displayLabels: [
                formatNumber(metrics.total),
                formatNumber(metrics.conversionBase),
                formatNumber(metrics.signed),
            ],
            colors: ['#457de6', '#17a2b8', '#ab71cb'],
            statusMap: [null, null, 'Y']
        };

        const funnelConfig = type === 'service' ? serviceFunnel : (type === 'marketing' ? marketingFunnel : firstFunnel);

        funnelChart?.destroy();
        funnelChart = new Chart(
            document.getElementById('chartFunnel').getContext('2d'),
            {
                type: 'funnel',
                data: {
                    labels: funnelConfig.labels,
                    datasets: [{
                        label: 'Количество',
                        data: funnelConfig.data,
                        shrinkAnchor: 'bottom',
                        backgroundColor: funnelConfig.colors
                    }]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    indexAxis: 'y',
                    plugins: {
                        datalabels: {
                            align: 'center',
                            color: '#fff',
                            font: {
                                size: 25,
                            },
                            formatter: function(value, context) {
                                const display = funnelConfig.displayLabels?.[context.dataIndex];
                                if (display) {
                                    return display;
                                }
                                const label = context.chart.data.labels?.[context.dataIndex] ?? '';
                                return `${label} — ${formatNumber(value)}`;
                            }
                        },
                        legend: {
                            position: 'bottom',
                        }
                    },
                    onClick: (event, elements) => {
                        if (!elements.length) {
                            return;
                        }
                        const index = elements[0].index;
                        const status = funnelConfig.statusMap[index];
                        let filter = {
                            date_from: $('#date_from').val(),
                            date_to: $('#date_to').val(),
                            admin: $('#admin').val(),
                            company: $('#company').val(),
                        }
                        switch (type) {
                            case 'first':
                                applyFirstPatientTypeFilter(filter)
                                if (index === 2) {
                                    filter.analytics_conversion_success = 1;
                                    delete filter.is_exception_error;
                                }
                                break;
                            case 'service':
                                filter.type = 'service'
                                filter.service_type = 'patient_cancel'
                                break;
                            case 'marketing':
                                filter.type = 'marketing'
                                filter.is_exception_error = 1
                                break;
                        }

                        if (status && !(type === 'first' && index === 2)) {
                            filter.status_signed = status
                        }

                        window.open(getRecordsLink(filter), '_blank');
                    }
                },
                plugins: [ChartDataLabels]
            }
        );

        // создаем отдельную воронку для упущенных пациентов
        const funnelNoSignetConfig = {
            labels: [
                'Упущенные пациенты (не записались)'
            ],
            data: [
                metrics.notSigned
            ],
            displayLabels: [
                formatNumber(metrics.notSigned),
            ],
            colors: ['#dc3545'],
            statusMap: ['N']
        };

        const funnelNoSignetCanvas = document.getElementById('chartFunnelNotSignet');
        if (funnelNoSignetCanvas) {
            funnelChartNoSignet?.destroy();
            funnelChartNoSignet = new Chart(
                funnelNoSignetCanvas.getContext('2d'),
                {
                    type: 'funnel',
                    data: {
                        labels: funnelNoSignetConfig.labels,
                        datasets: [{
                            label: 'Количество',
                            data: funnelNoSignetConfig.data,
                            shrinkAnchor: 'bottom',
                            backgroundColor: funnelNoSignetConfig.colors
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        indexAxis: 'y',
                        plugins: {
                            datalabels: {
                                align: 'center',
                                color: '#fff',
                                font: {
                                    size: 25,
                                },
                                formatter: function(value, context) {
                                    const display = funnelNoSignetConfig.displayLabels?.[context.dataIndex];
                                    if (display) {
                                        return display;
                                    }
                                    const label = context.chart.data.labels?.[context.dataIndex] ?? '';
                                    return `${label} — ${formatNumber(value)}`;
                                }
                            },
                            legend: {
                                position: 'bottom',
                            }
                        },
                        onClick: (event, elements) => {
                            if (!elements.length) {
                                return;
                            }
                            const index = elements[0].index;
                            const status = funnelNoSignetConfig.statusMap[index];
                            let filter = {
                                date_from: $('#date_from').val(),
                                date_to: $('#date_to').val(),
                                admin: $('#admin').val(),
                                company: $('#company').val(),
                            }
                            switch (type) {
                                case 'first':
                                    applyFirstPatientTypeFilter(filter)
                                    break;
                                case 'service':
                                    filter.type = 'service'
                                    filter.service_type = 'patient_cancel'
                                    break;
                                case 'marketing':
                                    filter.type = 'marketing'
                                    filter.is_exception_error = 1
                                    break;
                            }

                            if (status) {
                                filter.status_signed = status
                            }

                            window.open(getRecordsLink(filter), '_blank');
                        }
                    },
                    plugins: [ChartDataLabels]
                }
            );
        }
    }

    // === ОБНОВЛЁННАЯ ФУНКЦИЯ С ГРУППИРОВКОЙ ===
    const renderLineChartPoints = (elementId, points, unit = 'day') => {
        // сгруппированные данные
        const grouped = groupPointsByUnit(points, unit, getBucketStart);

        const labels = grouped.map(row => formatDate(row.date));
        const pointLabels = Object.keys(data?.pointLabels || {});
        // оставляем только этапы, по которым есть хотя бы одна оценка
        const activeLabels = pointLabels.filter(label => grouped.some(pt => pt.points[label] != null));
        const color = [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
        ];

        lineChartPoints[elementId]?.destroy();

        lineChartPoints[elementId] = new Chart(
            document.getElementById(elementId).getContext('2d'),
            {
                type: 'line',
                data: {
                    labels,
                    datasets: activeLabels.map((label, key) => ({
                        label: data?.pointLabels[label],
                        data: grouped.map(pt => pt.points[label] != null ? pt.points[label] : null),
                        borderColor: color[key % color.length],
                        backgroundColor: color[key % color.length],
                        borderWidth: 1,
                        fill: false,
                        cubicInterpolationMode: 'monotone',
                        tension: 0.4,
                        hidden: false,
                        pointRadius: 0,
                        spanGaps: true
                    }))
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        datalabels: {
                            backgroundColor: (ctx) => ctx.dataset.backgroundColor,
                            borderRadius: 4,
                            color: 'white',
                            font: { weight: 'bold' },
                            formatter: (v) => {
                                if (v == null || Number.isNaN(v)) {
                                    return '';
                                }
                                return Math.round(v);
                            },
                            padding: 6
                        },
                        legend: { position: 'bottom' },
                        tooltip: {
                            callbacks: {
                                title(items) {
                                    // если formatDate красивый — можно использовать его
                                    return labels[items[0].dataIndex];
                                }
                            }
                        }
                    },
                    // если хочешь time-ось — раскомментируй ниже и подавай точки как {x,y}
                    // scales: { x: { type: 'time', time: { unit } } }
                },
                plugins: [ChartDataLabels]
            }
        );
    };

    const renderChartPoints = (elementId, value) => {

        value = Math.min(value, 100);
        value = Math.round(value);

        if (isNaN(value)) {
            return;
        }

        $('#' + elementId).next().html(value + '%');

        chartPoints[elementId]?.destroy();

        chartPoints[elementId] = new Chart(
            document.getElementById(elementId).getContext('2d'),
            {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: [value, 100 - value],
                            backgroundColor: [
                                value > 50 ? 'rgb(75, 192, 192)' : 'rgb(255, 99, 132)',
                                'rgb(201, 203, 207)'
                            ],
                        }
                    ]
                },
                options: {
                    responsive: true, // График адаптируется к размеру экрана
                    maintainAspectRatio: false, // Позволяет изменять высоту вручную
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    }
                },
            }
        )
    }

    init()
}
